import { render, staticRenderFns } from "./BasePositionSelector.vue?vue&type=template&id=9e57ea4e&"
import script from "./BasePositionSelector.vue?vue&type=script&lang=js&"
export * from "./BasePositionSelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports